export enum UmsRoles {
  StandardUser = 'Standard User',
  PowerUser = 'Power User',
  WorkspaceOwner = 'Workspace Owner',
  WorkspaceUserAdministrator = 'Workspace User Administrator',
}
